import { DatePipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TableRowDirective } from '@core/primevue/directives/table-row.directive';
import { JobopslagService } from '@features/letpensiondk/letpensiondk-jobopslag/jobopslag.service';
import { PrimeTemplate } from 'primeng/api';
import { Checkbox } from 'primeng/checkbox';
import { IconField } from 'primeng/iconfield';
import { InputIcon } from 'primeng/inputicon';
import { InputText } from 'primeng/inputtext';
import { TableModule, TableRowSelectEvent } from 'primeng/table';
import { Toolbar } from 'primeng/toolbar';

@Component({
  selector: 'app-letpensiondk-jobopslag-list',
  imports: [
    DatePipe,
    PrimeTemplate,
    TableModule,
    TableRowDirective,
    Checkbox,
    FormsModule,
    IconField,
    InputIcon,
    InputText,
    Toolbar,
  ],
  templateUrl: './letpensiondk-jobopslag-list.component.html',
  styleUrl: './letpensiondk-jobopslag-list.component.css',
})
export class LetpensiondkJobopslagListComponent {
  jobopslagService = inject(JobopslagService);

  data = this.jobopslagService.datasource.data;

  onRowSelect(e: TableRowSelectEvent) {
    this.jobopslagService.selectJobopslag(e.data);
  }
}
